import React, {useEffect, useState} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import {RoutePath, RouteRestriction} from "../enums";
import {AuthGuard} from "./AuthGuard";
import {AdminPortalScreen} from "./AdminPortalScreen";
import {AdminLoginScreen} from "./AdminLoginScreen";
import {CustomerPortalScreen} from './CustomerPortalScreen';
import {LoginScreen} from './LoginScreen';
import {useAuth} from "../providers/AuthProvider";
import {LoadingIndicator} from "./LoadingIndicator";

export const App = () => {
    const {isLoading} = useAuth();
    const [isAnimationPlaying, setIsAnimationPlaying] = useState(true);

    useEffect(() => {
        const animationTimeout = setTimeout(() => {
            setIsAnimationPlaying(false);
        }, 1000);

        return () => clearTimeout(animationTimeout);
    }, []);

    return isLoading || isAnimationPlaying ?
        <LoadingIndicator/> :
        <Routes>
            <Route path={RoutePath.SIGN_IN} element={<LoginScreen/>}/>
            <Route path={RoutePath.CUSTOMER_PORTAL}
                   element={
                       <AuthGuard restriction={RouteRestriction.CUSTOMER_ONLY}>
                           <CustomerPortalScreen/>
                       </AuthGuard>
                   }/>
            <Route path={RoutePath.ADMIN_SIGN_IN} element={<AdminLoginScreen/>}/>
            <Route path={RoutePath.ADMIN_PORTAL}
                   element={
                       <AuthGuard restriction={RouteRestriction.ADMIN_ONLY}>
                           <AdminPortalScreen/>
                       </AuthGuard>
                   }/>

            <Route path="*" element={<Navigate to={RoutePath.SIGN_IN} replace/>}/>
        </Routes>;
}
